import service from '@/utils/request'
import qs from 'qs'

export function login (data) {
  return service.service({
    url: service.serviceApi + 'login',
    method: 'post',
    data: qs.stringify(data)
  })
}

export function wechatLogin (code) {
  return service.service({
    url: service.serviceApi + 'login',
    method: 'get',
    params: {code}
  })
}

export function Register (data) {
  return service.service({
    url: service.serviceApi + 'Register',
    method: 'post',
    data: qs.stringify(data)
  })
}

export function getMobile (memId) {
  return service.service({
    url: service.serviceApi + 'member.getmobile',
    method: 'get',
    params: {memId}
  })
}

export function Verify (data) {
  return service.service({
    url: service.serviceApi + 'Verify',
    method: 'post',
    data: qs.stringify(data)
  })
}

export function getInfo (token) {
  return service({
    url: '/user/info',
    method: 'get',
    params: { token }
  })
}

export function logout () {
  return service({
    url: '/user/logout',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js